import { fetchAuthSession } from "aws-amplify/auth";

// Helper function to get access token for GraphQL operations
export const getAccessToken = async (): Promise<string | undefined> => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.accessToken?.toString();
    return token;
  } catch (error) {
    console.error("Failed to get access token:", error);
    return undefined;
  }
};

// Helper function to get access token with lambda authorizer prefix
export const getAccessTokenForLambdaAuth = async (): Promise<
  string | undefined
> => {
  try {
    const token = await getAccessToken();
    if (!token) {
      return undefined;
    }
    // Prepend "X" as workaround for backend resolver to use custom lambda authorizer
    return "X" + token;
  } catch (error) {
    console.error("Failed to get access token for lambda:", error);
    return undefined;
  }
};
